import { IApplicationState } from 'shared/types/redux';

export const selectMasterButton = (state: IApplicationState) => state.landing.activeMasterButton;
